export default "__VITE_ASSET__tW7P8xdK__"